/**
 * DevExtreme (esm/renovation/ui/scheduler/consts.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var VERTICAL_GROUP_ORIENTATION = "vertical";
export var HORIZONTAL_GROUP_ORIENTATION = "horizontal";
